import { useQuery } from '@tanstack/react-query';
import { getTherapeuticStyles } from '@uplift/api';
import { PROFILE_ROW_QUERY_KEYS } from '../profile.utils';
import { CheckboxGroup } from '@uplift/ui-v2';

export type TherapueticStyleFormProps = {
  hideLabel?: boolean;
};

export const TherapueticStyleForm: React.VFC<TherapueticStyleFormProps> = props => {
  const { data: therapeuticStyles = [], isInitialLoading: loading } = useQuery(PROFILE_ROW_QUERY_KEYS.therapeuticStyle, async () => {
    const response = await getTherapeuticStyles();

    return response.data;
  });

  return (
    <div>
      <CheckboxGroup
        label={props.hideLabel ? undefined : '(Optional)'}
        name="therapeuticStyles"
        options={therapeuticStyles.map(({ name, id, description }) => ({ label: name, value: id, description }))}
        loading={loading}
      />
    </div>
  );
};
